// client/nodes/grid/config.ts
import { GRID_CELL_KEY, GRID_KEY, GRID_SCHEMA } from "../../../schema/nodes/grid.js";
import { PARAGRAPH_KEY } from "../../../schema/nodes/paragraph.js";
import { runInsertNode } from "../../helper/runInsertNode.js";
import { MenuItemGroup } from "../../types.js";
import { isNodeSelection } from "../../util.js";
import { editor } from "./editor.js";
import "./node-grid.js";
var grid = () => ({
  node: {
    name: GRID_KEY,
    schema: GRID_SCHEMA()
  },
  menuItems: [
    {
      group: MenuItemGroup.LAYOUT,
      label: "Grid",
      icon: "grid_on",
      run: (view) => runInsertNode(GRID_KEY, (state) => {
        return {
          content: [state.schema.nodes[GRID_CELL_KEY].create(null, [state.schema.nodes[PARAGRAPH_KEY].create()])]
        };
      })(view.state, view),
      shouldVisualize: (view) => {
        return !isNodeSelection(view.state.selection);
      }
    }
  ],
  editor
  //   plugins: (schema: Schema) => [gridViewPlugin],
});
export {
  grid
};
